import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
export const wrapRootElement = ({ element }) => {
    return (
        <GoogleReCaptchaProvider reCaptchaKey="6LeuLo4bAAAAAMkEBIgcR9jHTkN5ehqMHryBBQ13">
            {element}
        </GoogleReCaptchaProvider>
    )
}